import { render, staticRenderFns } from "./MessageModalComponent.vue?vue&type=template&id=6376d23b&scoped=true&"
import script from "./MessageModalComponent.vue?vue&type=script&lang=js&"
export * from "./MessageModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6376d23b",
  null
  
)

export default component.exports